export default __webpack_public_path__ + "static/media/cgu_icon.9824709a.png";